const ErrorHelper = {
  loanErrorParser: (error) => {
    const errorInfo = {
      code: error.code.toLowerCase(),
      message: 'Ocorreu um erro. Tente novamente.',
    };

    // If the error is `email already registered`.
    if (error.code.toLowerCase() === 'loan.application.noseller') {
      errorInfo.message = 'Venda existente';
    }

    // If the error is `tax id already registered`.
    else if (error.code.toLowerCase() === 'person.taxid.exists' || error.code.toLowerCase() === 'user.taxid.exists') {
      errorInfo.message = 'O CPF já está cadastrado';
    }
    // If the CPF is invalid
    else if (error.code.toLowerCase() === 'person.taxid.cpf') {
      errorInfo.message = 'O CPF não é válido';
    }
    // If one of the infos has been used in a loan
    else if (error.code.toLowerCase() === 'person.notfound') {
      errorInfo.message = 'Um dos dados já está sendo usado';
    } else if (
      error.code.toLowerCase() === 'person.contacts.primaryemailaddress.address.notempty' ||
      error.code.toLowerCase() === 'person.contacts.emailaddresses[].address.notempty'
    ) {
      errorInfo.message = 'E-mail deve ser preenchido';
    } else if (error.code.toLowerCase() === 'person.contacts.emailaddresses[].address.email') {
      errorInfo.message = 'E-mail inválido';
    } else if (
      error.code.toLowerCase() === 'person.emailaddress.exists' ||
      error.code.toLowerCase() === 'user.emailaddress.exists'
    ) {
      errorInfo.message = 'O email já está cadastrado';
    }

    // If the error is `phone number registered`.
    else if (
      error.code.toLowerCase() === 'person.phonenumber.exists' ||
      error.code.toLowerCase() === 'user.phonenumber.exists'
    ) {
      errorInfo.message = 'O celular já está cadastrado';
    } else if (
      error.code.toLowerCase() === 'person.contacts.phonenumbers[].number.notnull' ||
      error.code.toLowerCase() === 'person.contacts.primaryphonenumber.number.notnull'
    ) {
      errorInfo.message = 'Celular deve ser preenchido';
    } else if (
      error.code.toLowerCase() === 'person.contacts.phonenumbers[].numberstring.pattern' ||
      error.code.toLowerCase() === 'person.contacts.primaryphonenumber.numberstring.pattern'
    ) {
      errorInfo.message = 'Celular inválido';
    } else if (error.code.toLowerCase() === 'loan.application.employment.kind.notnull') {
      errorInfo.message = 'Escolha sua fonte de renda';
    } else if (error.code.toLowerCase() === 'loan.application.employment.payday.notnull') {
      errorInfo.message = 'Informe o dia que você recebe seu pagamento';
    } else if (error.code.toLowerCase() === 'loan.application.employment.actualmonthlyincome.notnull') {
      errorInfo.message = 'Informe quanto você recebe por mês';
    } else if (error.code.toLowerCase() === 'loan.application.termsandconditionsconsent.asserttrue') {
      errorInfo.message = 'Leia e aceite os termos e condições';
    }

    return errorInfo;
  },

  removeDuplicates: (arr) => {
    const obj = {};
    const retArr = [];
    for (let i = 0; i < arr.length; i++) {
      obj[arr[i]] = true;
    }
    for (const key in obj) {
      retArr.push(key);
    }
    return retArr;
  },

  // eslint-disable-next-line arrow-body-style
  lazyRetry: (componentImport) => {
    return new Promise((resolve, reject) => {
      // check if the window has already been refreshed
      const hasRefreshed = JSON.parse(window.sessionStorage.getItem('retry-lazy-refreshed') || 'false');

      // try to import the component
      componentImport()
        .then((component) => {
          window.sessionStorage.setItem('retry-lazy-refreshed', 'false'); // success so reset the refresh
          resolve(component);
        })
        .catch((error) => {
          if (!hasRefreshed) {
            // not been refreshed yet
            window.sessionStorage.setItem('retry-lazy-refreshed', 'true'); // we are now going to refresh
            return window.location.reload(); // refresh the page
          }
          reject(error); // Default error behaviour as already tried refresh
        });
    });
  },
};

export default ErrorHelper;
